/**
 * The metric-targets React Query key, in a module of its own so code that
 * only invalidates the cache (the AI chat's confirm, 86e3g6ww3) does not pull
 * in the API client with it.
 */
export const METRIC_TARGETS_QUERY_KEY = 'metric-targets'
